import React from 'react'
import NumberFormat from 'react-number-format'

const NumberFormatCustom = props => {
  const { inputRef, onChange, allowNull, ...rest } = props
  return (
    <NumberFormat
      {...rest}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: Number(values.value)
          }
        })
      }}
      isNumericString
      allowNegative={false}
      thousandSeparator="."
      decimalSeparator=","
      prefix="R$ "
      decimalScale={2}
      isAllowed={value => {
        const { floatValue } = value

        if (allowNull && !floatValue) return true

        return floatValue > 0 && floatValue < 1000000000
      }}
    />
  )
}

export default NumberFormatCustom
